abstract class BasePanel {
  protected isCreated = false;
  protected mainPanelElement: HTMLDivElement;
  protected panelContentDiv: HTMLDivElement;

  constructor() {
    this.createCommentsPanel();
  }

  protected abstract moveAdUnitTo(direction: 'comments-panel' | 'original-spot'): void;

  protected onPanelClose() {
    this.mainPanelElement.style.height = '0';
    // Move the CW ad back to it's original position
    this.moveAdUnitTo('original-spot');
    // Enable scrolling in the main document again
    document.body.style.removeProperty('touch-action');
    document.body.style.removeProperty('overflow');
  }

  public showPanel() {
    this.mainPanelElement.style.height = '100%';
    // Move the ad unit from above the original CW on the page to inside the comments panel
    this.moveAdUnitTo('comments-panel');
    // Disable scrolling in the main document
    document.body.style.setProperty('touch-action', 'none');
    document.body.style.setProperty('overflow', 'hidden');
  }

  protected createCommentsPanel() {
    if (!this.isCreated) {
      this.isCreated = true;
      const panelElement = document.createElement('div');
      panelElement.tabIndex = -1;
      panelElement.style.cssText = `
        height: 0;
        bottom: 0px;
        left: 0px;
        position: fixed;
        width: 100%;
        max-width: 100%;
        min-width: 100%;
        z-index: 100000;
        outline: none;
        transition: 0.3s all ease;
      `;
      this.mainPanelElement = panelElement;

      const panelContentContainer = document.createElement('div');
      panelContentContainer.style.cssText = `
        transition: 0.3s all ease;
        position: absolute;
        background: rgb(255, 255, 255);
        bottom: 0px;
        height: 85%;
        max-height: calc(100% - 100px);
        max-width: 100%;
        min-width: 100%;
        box-shadow: rgb(204, 204, 204) 0px -2px 8px;    
      `;

      const panelContentElement = document.createElement('div');
      panelContentElement.style.cssText = `
        margin: 0px auto;
        min-width: 100%;
        z-index: 1;
        height: 100%;
        position: relative;
        width: 100%;
        overflow: auto;
      `;

      const panelIframeContainer = document.createElement('div');
      panelIframeContainer.style.cssText = `
        max-width: 700px;
        margin: 60px auto;
        margin-bottom: 10px;
      `;

      this.panelContentDiv = panelIframeContainer;

      const panelCloseButton = document.createElement('button');
      panelCloseButton.style.cssText = `
        display: flex;
        justify-content: flex-end;
        position: absolute;
        align-items: center;
        cursor: pointer;
        right: 15px;
        top: 15px;
        color: rgb(0, 0, 0);
        font-size: 10px;
        font-weight: 900;
        line-height: 0.7;
        z-index: 100000;
        border: none;
        background: #fff;
      `;
      panelCloseButton.textContent = 'Close Panel';
      panelCloseButton.insertAdjacentHTML(
        'beforeend',
        `
          <svg width="18px" height="18px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 5V19M12 19L6 13M12 19L18 13" stroke="#000000" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        `
      );
      panelCloseButton.addEventListener('click', this.onPanelClose.bind(this));

      panelElement.appendChild(panelContentContainer);
      panelContentContainer.appendChild(panelContentElement);
      panelContentElement.appendChild(panelCloseButton);
      panelContentElement.appendChild(panelIframeContainer);
      document.body.appendChild(panelElement);
    }
  }
}

export default BasePanel;
